import { useTranslation as usei18nTranslation } from 'react-i18next';

export const useTranslation = () => {
  const { t, i18n } = usei18nTranslation();

  return { language: i18n.language, setLanguage: i18n.changeLanguage, t };
};
